import {
  AfterViewInit,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  effect,
  HostListener,
  inject,
  OnDestroy,
  OnInit,
  signal
} from '@angular/core';
import {NavigationEnd, Router, RouterOutlet} from '@angular/router';

import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {Keyboard, KeyboardStyle} from "@capacitor/keyboard";
import {ScreenOrientation} from "@capacitor/screen-orientation";
import {environment} from "src/app/environments/environment";
import {SafeArea} from "capacitor-plugin-safe-area";
import {ViewportService} from "src/app/infrastructure/viewport.service";
import {oneMinute} from "src/app/presentation/common/globals";
import {DataSynchronisationService} from "src/app/infrastructure/data-synchronisation.service";
import {NetworkStatusStore} from "src/app/infrastructure/network/network-status.store";
import {PushNotificationService} from "src/app/infrastructure/push-notification.service";
import {BootstrapService} from "src/app/infrastructure/init/bootstrap.service";
import {SplashScreen} from '@capacitor/splash-screen';
import {Capacitor} from '@capacitor/core';
import {InitService} from 'src/app/infrastructure/init/init.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {MapStateService} from 'src/app/presentation/main-view/map-container/map-container-component';

{
  if (!['web', ''].includes(environment.platform)) {
    Keyboard.addListener('keyboardWillShow', (info) => {
      document.body.style.paddingBottom = `${info.keyboardHeight}px`;
    });

    Keyboard.setStyle({style: KeyboardStyle.Light})
    Keyboard.addListener('keyboardWillHide', () => {
      document.body.style.paddingBottom = 'env(safe-area-inset-bottom)';
    });

    if (Capacitor.getPlatform() === 'ios') {
      SafeArea.getSafeAreaInsets().then(({insets}) => {
        for (const [key, value] of Object.entries(insets)) {
          document.documentElement.style.setProperty(
            `--safe-area-inset-${key}`,
            `${value}px`,
          );
        }
      });
    }

    ScreenOrientation.lock({orientation: 'portrait'});
  }
}

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NgbModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {

  render = signal(false);

  private readonly networkStatusStore = inject(NetworkStatusStore);
  private readonly router = inject(Router);
  private readonly initService = inject(InitService);
  private readonly dataSynchronisationService = inject(DataSynchronisationService);
  private readonly viewportService = inject(ViewportService);
  private readonly pushNotificationService = inject(PushNotificationService);
  private readonly bootstrapService = inject(BootstrapService);
  private readonly mapStateService = inject(MapStateService);
  constructor() {
    this.router.events.pipe(takeUntilDestroyed()).subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.mapStateService.removeLocator();
      }
    });

    effect(() => {
      if (this.networkStatusStore.isOnline()) {
        this.dataSynchronisationService.synchronise();
      }
    });
  }

  async ngOnInit(): Promise<void> {
    await this.initService.openDatabaseConnection();
    this.render.set(true);

    this.initService.setUpApp();
    this.networkStatusStore.init();
    this.pushNotificationService.init();

    setInterval(() => {
      this.dataSynchronisationService.synchronise();
    }, oneMinute);
  }

  ngAfterViewInit(): void {
    SplashScreen.hide();
  }

  ngOnDestroy(): void {
    this.bootstrapService.destroy()
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.viewportService.checkViewportSize();
  }
}
